import {
    BACKEND_AVAILABLE,
    BACKEND_REQUEST,
    BACKEND_UNAVAILABLE,
    CUSTOM_AVAILABLE_EXCEL,
    SNACK_SET,
} from './constants';
import { createReducer } from './utils';

const defaultState = {
    loading_tasks: false,
    loading_chains: false,
    loading_products: false,
    products_list: [],
    chainsList: [],
    taskList: [],
};

export const reducer = createReducer(defaultState, {
    [BACKEND_REQUEST]: handleCustomRequest,
    [BACKEND_AVAILABLE]: handleCustomAvailable,
    [BACKEND_UNAVAILABLE]: handleCustomUnavailable,
});


function handleCustomRequest(state, { payload: { loadingName } }) {
    return {
        ...state,
        [loadingName]: true,
    };
}

function handleCustomAvailable(state, { payload: { keyState, loadingName, requestInfo, aditionalStates = {} } }) {
    const x = {
        ...state,
        [loadingName]: false,
        [keyState]: requestInfo,
        ...aditionalStates,
    };
    return x
}

function handleCustomUnavailable(state, { payload: { keyState, loadingName } }) {
    return {
        ...state,
        [keyState]: [],
        [loadingName]: false,
    };
}

export function getProducts(product_id = null) {
    return async (dispatch, _, { services: { dataSource } }) => {
        dispatch({ type: BACKEND_REQUEST, payload: { loadingName: 'loading_products' } });
        try {
            const productsResponse = await dataSource.getProducts(product_id);
            dispatch({
                type: BACKEND_AVAILABLE,
                payload: {
                    keyState: 'productsList',
                    loadingName: 'loading_products',
                    requestInfo: productsResponse.products_list,
                },
            });
        } catch (error) {
            console.log('error: ', error);
            dispatch({
                type: BACKEND_UNAVAILABLE,
                payload: { error, keyState: 'productsList', loadingName: 'loading_products' },
            });
            const snack = {
                open: true,
                message: 'There was an error',
                severity: 'error',
            };
            dispatch({ type: SNACK_SET, payload: { snack } });
        }
    };
}

export function getTasks(task_id = null) {
    return async (dispatch, _, { services: { dataSource } }) => {
        dispatch({ type: BACKEND_REQUEST, payload: { loadingName: 'loading_tasks' } });
        try {
            const tasksResponse = await dataSource.getTasks(task_id);
            dispatch({
                type: BACKEND_AVAILABLE,
                payload: { keyState: 'tasksList', loadingName: 'loading_tasks', requestInfo: tasksResponse.tasks_list },
            });
        } catch (error) {
            console.log('error: ', error);
            dispatch({
                type: BACKEND_UNAVAILABLE,
                payload: { error, keyState: 'tasksList', loadingName: 'loading_tasks' },
            });
            const snack = {
                open: true,
                message: 'There was an error',
                severity: 'error',
            };
            dispatch({ type: SNACK_SET, payload: { snack } });
        }
    };
}

export function getChains(chain_id = null) {
    return async (dispatch, _, { services: { dataSource } }) => {
        dispatch({ type: BACKEND_REQUEST, payload: { loadingName: 'loading_chains' } });
        try {
            const chainsResponse = await dataSource.getChains(chain_id);
            dispatch({
                type: BACKEND_AVAILABLE,
                payload: { keyState: 'chainsList', loadingName: 'loading_chains', requestInfo: chainsResponse.chains_list },
            });
        } catch (error) {
            console.log('error: ', error);
            dispatch({
                type: BACKEND_UNAVAILABLE,
                payload: { error, keyState: 'chainsList', loadingName: 'loading_chains' },
            });
            const snack = {
                open: true,
                message: 'There was an error',
                severity: 'error',
            };
            dispatch({ type: SNACK_SET, payload: { snack } });
        }
    };
}

